import { useEffect, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import { usePopupStore } from '../../stores/popupStore';

// B1：温馨提示弹窗（免费用户进入 3D 编辑器自动弹）
// - 关闭按钮 N 秒倒计时（默认 10s）后才可点
// - 「不再提示」= 仅本次不弹（刷新后恢复），点击后立即弹套餐订阅弹窗
export default function NoticePopup() {
  const noticeOpen = usePopupStore((s) => s.noticeOpen);
  const notice = usePopupStore((s) => s.config.notice);
  const closeNotice = usePopupStore((s) => s.closeNotice);
  const dismissNotice = usePopupStore((s) => s.dismissNotice);

  const total = Math.max(0, Number(notice?.countdownSeconds ?? 10));
  const [left, setLeft] = useState(total);

  useEffect(() => {
    if (!noticeOpen) return;
    setLeft(total);
    if (total <= 0) return;
    const t = setInterval(() => setLeft((v) => (v <= 1 ? 0 : v - 1)), 1000);
    return () => clearInterval(t);
  }, [noticeOpen, total]);

  const disabled = left > 0;

  return (
    <Modal
      open={noticeOpen}
      footer={null}
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      centered
      width={540}
      styles={{ body: { padding: '22px 26px 18px' } }}
    >
      <div data-testid="notice-popup" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 19, fontWeight: 700, color: '#e8e8e8', marginBottom: 14 }}>
          {notice?.title || '温馨提示'}
        </div>
        <div style={{ fontSize: 13, color: '#c9c9d4', lineHeight: 1.9, textAlign: 'left', marginBottom: 18 }}>
          {notice?.content}
        </div>

        {(notice?.wechatQrUrl || notice?.servicePhone) && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 26, marginBottom: 18 }}>
            {notice?.wechatQrUrl ? (
              <div style={{ textAlign: 'center' }}>
                <img
                  src={notice.wechatQrUrl}
                  alt="微信客服"
                  style={{ width: 112, height: 112, objectFit: 'contain', background: '#fff', borderRadius: 6, padding: 4 }}
                />
                <div style={{ fontSize: 11, color: '#8a8a99', marginTop: 4 }}>微信客服</div>
              </div>
            ) : null}
            {notice?.servicePhone ? (
              <div style={{ textAlign: 'left', fontSize: 12, color: '#b8b8c8', lineHeight: 2 }}>
                <div>电话客服：{notice.servicePhone}</div>
                {notice.serviceHours ? <div>{notice.serviceHours}</div> : null}
              </div>
            ) : null}
          </div>
        )}

        <Space size={12}>
          <Button data-testid="notice-dismiss" onClick={dismissNotice}>
            {notice?.dismissLabel || '不再提示'}
          </Button>
          <Button
            type="primary"
            data-testid="notice-close"
            disabled={disabled}
            onClick={closeNotice}
          >
            {disabled ? `${notice?.closeLabel || '关闭'}(${left}s)` : notice?.closeLabel || '关闭'}
          </Button>
        </Space>
      </div>
    </Modal>
  );
}
